import React from 'react'
import facetTracemark from '../pages/end_user_page/images/FACET_TRACEMARK.png'

const dataConstant = {
  pagination: {
    // defaultPageNumber: 1,
    defaultPageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
  },
  SupportedFileType: [
    {
      label: '.pdf',
      value: '.pdf',
    },
    {
      label: '.doc',
      value: '.doc',
    },
    {
      label: '.xl',
      value: '.xl',
    },
    {
      label: '.jpg',
      value: '.jpg',
    },
    {
      label: '.png',
      value: '.png',
    },
  ],
  ProductCategroy: [
    { id: 1, value: 'Metal', label: 'Metal' },
    { id: 2, value: 'Minerals', label: 'Minerals' },
    { id: 3, value: 'Findings', label: 'Findings' },
    { id: 4, value: 'Accessories', label: 'Accessories' },
    { id: 5, value: 'Certified Stones', label: 'Certified Stones' },
  ],
  ProductSubCategroy: [
    {
      id: 1,
      label: 'Diamond',
      value: 'D',
    },
    {
      id: 2,
      label: 'Gold',
      value: 'G',
    },
    {
      id: 3,
      label: 'Both',
      value: 'B',
    },
  ],
  SightHolders: [
    {
      label: 'DeBeers',
      value: 'DeBeers',
    },
    {
      label: 'Alrosa',
      value: 'Alrosa',
    },
    {
      label: 'RioTinto',
      value: 'RioTinto',
    },
    {
      label: 'Dominion',
      value: 'Dominion',
    },
  ],
  Roles: [
    {
      label: 'Admin',
      value: 'Admin',
      key: 'Admin',
      component: <div>Coming soon..</div>,
    },
    {
      label: 'Supplier',
      value: 'Supplier',
      key: 'Supplier',
      component: <div>Coming soon..</div>,
    },
    {
      label: 'Factory',
      value: 'Factory',
      key: 'Factory',
      component: <div>Coming soon..</div>,
    },
    {
      label: 'Client',
      value: 'clientlist',
      key: 'clientlist',
      component: <div>Coming soon..</div>,
    },
    {
      label: 'Auditor',
      value: 'Auditor',
      key: 'Auditor',
      component: <div>Coming soon..</div>,
    },
  ],
  Add: 'Add',
  Update: 'Update',
  Edit: 'Edit',
  Delete: 'Delete',
  Warning: 'Warning',
  Complete: 'Complete',
  Close: 'Close',
  Error: 'Error',
  AddAndUpload: 'Add and Upload',
  UpdateAndUpload: 'Update and Upload',
  ExportCsv: 'Export CSV',
  InwardType: [
    {
      label: 'Diamond',
      value: 'D',
    },
    {
      label: 'Gold',
      value: 'G',
    },
  ],
  InwardCategory: {
    Metal: 'Metal',
    Minerals: 'Minerals',
    Findings: 'Findings',
    Accessories: 'Accessories',
    CertifiedStones: 'Certified Stones',
    Both: 'Both',
  },
  RefType: {
    Inward: 'Inward',
    JewelleryArticle: 'Jewellery Article',
    Supplier: 'Supplier',
    Client: 'Client',
    General: 'General',
    TransferDocument: 'Transfer Document',
    Wholesaler: 'Wholesaler',
    CertifiedStoneTransferDocument: 'Certified Stone Transfer Document',
    CertifiedStone: 'Certified Stone',
  },
  DocumentType: {
    PurchaseOrder: {
      STEP1: 'STEP 1',
      Name: 'Purchase Order',
      Poexcelfile: 'PO Excel File',
    },
    AlphanumericCode: {
      STEP2: 'STEP 2',
      Name: 'Alphanumeric Code',
      AlphanumericCode: 'Alphanumeric Code',
      Poexcelfiles: 'PO Excel File',
    },
    Gold: {
      Name: 'Gold',
      GoldRefineryPurchasedInvoice: 'Gold Refinery Purchased Invoice',
      COCGoldTransferDocument: 'COC Gold Transfer Document',
      RefinerysTransferDocument: 'Refinerys Transfer Document',
      RefinerysRJCCOCCertificate: 'Refinerys RJC COC Certificate',
      RefinerysRJCCOPCertificate: 'Refinerys RJC COP Certificate',
    },
    Diamond: {
      Name: 'Diamond',
      DeliveryLabGrownDiamondDocument: 'Natural Diamond Documentation',
      LabIGICertificate: 'Lab-Grown Diamond Documentation',
    },
    Finding: {
      Name: 'Finding',
      RefinerysPurchasedInvoice: 'Refinerys Purchased Invoice',
      COCMaterialTransferDocument: 'COC Material Transfer Document',
      RefinerysRJCCOCCertificate: 'Refinery’s RJC COC Certificate',
    },
    FinalProcess: {
      STEP3: 'STEP 3',
      Name: 'Final Process',
      CSVexcelfile: 'CSV Excel File',
      JobCard: 'Job Card',
      SketchImages: 'Sketch Images',
      FinalImages: 'Final Images',
    },
  },
  UploadFileType: {
    PDFType: 'application/pdf,application/x-zip-compressed,application/zip',
    CSVType: 'text/csv',
    ZipType: 'application/x-zip-compressed,application/zip',
    xlsType:
      'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  FolderName: {
    Inward: 'Inward',
    ProfilePic: 'ProfilePic',
    JewelleryArticle: 'JeweleryArticle',
    TransferDocument: 'Transfer Document',
    Wholesaler: 'Wholesaler',
    CertifiedStoneTransferDocument: 'Certified Stone Transfer Document',
    CertifiedStone: 'Certified Stone',
    Supplier: 'Supplier',
    Client: 'Client',
  },
  UserProfile: {
    ProfilePicFileTypes: ['image/jpeg', 'image/png', 'image/jpg'],
    ProfilePicSize: 2097152,
    ProfilePicDefaultUrl: 'resources/images/TLS/NoImage.png',
    imgExtensions: ['jpg', 'jpeg', 'png'],
  },
  MaterialType: {
    Minerals: 'D',
    Metal: 'G',
    Findings: 'F',
    Accessories: 'A',
    Jewellery: 'J',
    CertifiedStone: 'C',
    All: 'All',
  },
  MaterialTypeArray: [
    {
      label: 'Minerals',
      value: 'D',
    },
    {
      label: 'Metal',
      value: 'G',
    },
    {
      label: 'Findings',
      value: 'F',
    },
    {
      label: 'Accessories',
      value: 'A',
    },
    {
      label: 'Jewelery',
      value: 'J',
    },
    {
      label: 'Certified Stones',
      value: 'C',
    },
    {
      label: 'All',
      value: 'All',
    },
  ],
  RoleType: {
    Supplier: 'Supplier',
    Factory: 'Factory',
    Auditor: 'Auditor',
    FactoryStaff: 'Factory Staff',
    FactoryAdmin: 'Factory Admin',
    Client: 'Client',
    Wholesaler: 'Wholesaler',
    Admin: 'Admin',
    FactoryFileUpload: 'Factory File Upload',
  },
  RefTye: {
    AlphanumericCode: 'AlphanumericCode',
    Gold: 'Gold',
    Diamond: 'Diamond',
    Finding: 'Finding',
    FinalProcess: 'FinalProcess',
  },
  Upload: 'Upload',
  dateFormat: 'MM/DD/YYYY',
  DocumentTypeList: [
    'Final Product',
    'Final Product Composition',
    'Sketch',
    'CAD Design',
    'Manufacturing',
    'Filling',
    'Setting',
    'Polishing',
    'Casting',
    'Lab Certificate',
    'IGI Certificate',
    'GIA Certificate',
  ],
  TousDocumentTypeList: ['Final Product', 'Final Product Composition'],
  CertificateTypeList: ['Lab Certificate', 'KP Certificate', 'Final Product'],

  ArticleStatusFilterList: [
    { label: 'Available', value: 'Available' },
    { label: 'Sold', value: 'Sold' },
    { label: 'Received Pending', value: 'Received Pending' },
  ],
  ArticleStatusList: [
    { label: 'Available', value: 'Available' },
    { label: 'Sold', value: 'Sold' },
  ],
  ArticleStatusObj: {
    Available: 'Available',
    Sold: 'Sold',
    ReceivedPending: 'Received Pending',
  },

  TwoFactorProvider: [{ label: 'Email', value: 'Email' }],

  TwoFactorProviderObj: {
    Email: 'Email',
    SMS: 'SMS',
  },

  ImportConfigurationObj: [
    {
      Module: 'Jewellery Article',
      Type: 'jewellery-article',
      MappingFieldsObject: 'JeweleryArticleMappingField',
      PageTitle: 'Import Jewellery Article',
      ImportAPIURL: 'JewelryArticleImport',
      SampleFileName: 'JewelleryArticleSample.csv',
      ErrorFileName: 'TLSJewelleryArticleDetailImportError.csv',
      BackToListURL: '/factory/jewellery-articles',
      FinalMessage: 'Great, your jewellery article details uploaded successfully!',
    },
    {
      Module: 'Inward',
      Type: 'inward-minerals',
      MappingFieldsObject: 'InwardMappingField',
      PageTitle: 'Import Inward - Minerals',
      ImportAPIURL: 'InwardImport',
      SampleFileName: 'InwardSample.csv',
      ErrorFileName: 'TLSInwardDetailImportError.csv',
      BackToListURL: '/inward/Minerals',
      FinalMessage: 'Great, your inward details uploaded successfully!',
    },
    {
      Module: 'Inward',
      Type: 'inward-metal',
      MappingFieldsObject: 'InwardMappingField',
      PageTitle: 'Import Inward - Metals',
      ImportAPIURL: 'InwardImport',
      SampleFileName: 'InwardSample.csv',
      ErrorFileName: 'TLSInwardDetailImportError.csv',
      BackToListURL: '/inward/Metal',
      FinalMessage: 'Great, your inward details uploaded successfully!',
    },
    {
      Module: 'Inward',
      Type: 'inward-findings',
      MappingFieldsObject: 'InwardMappingField',
      PageTitle: 'Import Inward - Findings',
      ImportAPIURL: 'InwardImport',
      SampleFileName: 'InwardSample.csv',
      ErrorFileName: 'TLSInwardDetailImportError.csv',
      BackToListURL: '/inward/Findings',
      FinalMessage: 'Great, your inward details uploaded successfully!',
    },
    {
      Module: 'Inward',
      Type: 'inward-accessories',
      MappingFieldsObject: 'InwardMappingField',
      PageTitle: 'Import Inward - Accessories',
      ImportAPIURL: 'InwardImport',
      SampleFileName: 'InwardSample.csv',
      ErrorFileName: 'TLSInwardDetailImportError.csv',
      BackToListURL: '/inward/Accessories',
      FinalMessage: 'Great, your inward details uploaded successfully!',
    },
    {
      Module: 'Inward Certified Stone',
      Type: 'inward-certified stones',
      MappingFieldsObject: 'InwardCertifiedStoneMappingField',
      PageTitle: 'Import Inward - Certified Stones',
      ImportAPIURL: 'InwardImport',
      SampleFileName: 'InwardCertifiedStoneSample.csv',
      ErrorFileName: 'TLSInwardDetailImportError.csv',
      BackToListURL: '/inward/Certified Stones',
      FinalMessage: 'Great, your inward details uploaded successfully!',
    },
    {
      Module: 'RM Code Configuration',
      Type: 'rmcode',
      MappingFieldsObject: 'RMCodeMappingField',
      PageTitle: 'Import RMCode',
      ImportAPIURL: 'RMCodeImportAPI',
      SampleFileName: 'RMCodeImportSample.csv',
      ErrorFileName: 'TLSRMCodeImportError.csv',
      BackToListURL: '/RMCode',
      FinalMessage: 'Great, your rmcode uploaded successfully!',
    },
  ],
  JeweleryArticleMappingField: [
    { DisplayLabel: 'Export No', value: 'ExportNo', key: 'ExportNo', isRequired: true },
    { DisplayLabel: 'Export Date', value: 'ExportDate', key: 'ExportDate', isRequired: false },
    { DisplayLabel: 'Batch Card', value: 'BatchCardNo', key: 'BatchCardNo', isRequired: true },
    { DisplayLabel: 'Article Code', value: 'ArticleCode', key: 'ArticleCode', isRequired: true },
    { DisplayLabel: 'Color', value: 'Color', key: 'Color', isRequired: true },
    { DisplayLabel: 'Unique Code', value: 'TLSUniqueCode', key: 'TLSUniqueCode', isRequired: true },
    { DisplayLabel: 'Category', value: 'Category', key: 'Category', isRequired: true },
    { DisplayLabel: 'Qty', value: 'Qty', key: 'Qty', isRequired: true },
    { DisplayLabel: 'Carat', value: 'IdKt', key: 'IdKt', isRequired: false },
    { DisplayLabel: 'Gross Weight', value: 'GrossWeight', key: 'GrossWeight', isRequired: false },
    { DisplayLabel: 'Sold By', value: 'SoldBy', key: 'SoldBy', isRequired: false },
    { DisplayLabel: 'Client Code', value: 'ClientCode', key: 'ClientCode', isRequired: false },
    { DisplayLabel: 'RM No', value: 'RMNo', key: 'RMNo', isRequired: true },
    { DisplayLabel: 'Type', value: 'Type', key: 'Type', isRequired: true },
    {
      DisplayLabel: 'Sub Category',
      value: 'RMSubCategory',
      key: 'RMSubCategory',
      isRequired: true,
    },
    {
      DisplayLabel: 'Internal Code',
      value: 'InternalCode',
      key: 'InternalCode',
      isRequired: false,
    },
    { DisplayLabel: 'RM Size', value: 'RMSize', key: 'RMSize', isRequired: false },
    { DisplayLabel: 'RM Qty', value: 'RMQty', key: 'RMQty', isRequired: true },
    { DisplayLabel: 'RM Weight', value: 'RMWeight', key: 'RMWeight', isRequired: true },
    { DisplayLabel: 'LotNo', value: 'LotNo', key: 'LotNo', isRequired: true },
    {
      DisplayLabel: 'Ref Article Code',
      value: 'RefArticleCode',
      key: 'RefArticleCode',
      isRequired: false,
    },
    { DisplayLabel: 'Sub Type', value: 'SubTypes', key: 'SubTypes', isRequired: false },
    { DisplayLabel: 'KT', value: 'KT', key: 'KT', isRequired: false },
    { DisplayLabel: 'CertReportNo', value: 'CertReportNo', key: 'CertReportNo', isRequired: false },
  ],

  InwardMappingField: [
    { DisplayLabel: 'Supplier Code', value: 'SupplierCode', key: 'SupplierCode', isRequired: true },
    { DisplayLabel: 'Invoice No', value: 'InvoiceNo', key: 'InvoiceNo', isRequired: true },
    { DisplayLabel: 'Invoice Date', value: 'InvoiceDate', key: 'InvoiceDate', isRequired: true },
    { DisplayLabel: 'LotNo', value: 'LotNo', key: 'LotNo', isRequired: true },
    { DisplayLabel: 'Type', value: 'Type', key: 'Type', isRequired: true },
    {
      DisplayLabel: 'Bag Description',
      value: 'BagDescription',
      key: 'BagDescription',
      isRequired: true,
    },
    { DisplayLabel: 'Pcs/Cts', value: 'PcsPerCts', key: 'PcsPerCts', isRequired: false },
    {
      DisplayLabel: 'BagTotalWeight',
      value: 'BagTotalWeight',
      key: 'BagTotalWeight',
      isRequired: false,
    },
    {
      DisplayLabel: 'Internal Code',
      value: 'InternalCode',
      key: 'InternalCode',
      isRequired: false,
    },
    { DisplayLabel: 'Description', value: 'Description', key: 'Description', isRequired: false },
    { DisplayLabel: 'Carat', value: 'Cts', key: 'Cts', isRequired: true },
    { DisplayLabel: 'Pcs', value: 'Pcs', key: 'Pcs', isRequired: true },
    { DisplayLabel: 'Color', value: 'Color', key: 'Color', isRequired: false },
    { DisplayLabel: 'Shape', value: 'Shape', key: 'Shape', isRequired: false },
    { DisplayLabel: 'Size', value: 'Size', key: 'Size', isRequired: false },
    { DisplayLabel: 'Clarity', value: 'Clarity', key: 'Clarity', isRequired: false },
    {
      DisplayLabel: 'Ref Supplier Code',
      value: 'RefSupplierCode',
      key: 'RefSupplierCode',
      isRequired: false,
    },
    {
      DisplayLabel: 'Mining Companies',
      value: 'MiningCompanies',
      key: 'MiningCompanies',
      isRequired: true,
    },
    {
      DisplayLabel: 'Country Of Origin',
      value: 'CountryOfOrigin',
      key: 'CountryOfOrigin',
      isRequired: true,
    },
    {
      DisplayLabel: 'Synthetic Diamond Per',
      value: 'SyntheticDiamondPer',
      key: 'SyntheticDiamondPer',
      isRequired: false,
    },
    { DisplayLabel: 'Sub Types', value: 'SubTypes', key: 'SubTypes', isRequired: false },
    { DisplayLabel: 'Sub Category', value: 'SubCategory', key: 'SubCategory', isRequired: false },
    { DisplayLabel: 'KT', value: 'KT', key: 'KT', isRequired: false },
    { DisplayLabel: 'Notes', value: 'Notes', key: 'Notes', isRequired: false },
  ],
  InwardCertifiedStoneMappingField: [
    { DisplayLabel: 'Supplier Code', value: 'SupplierCode', key: 'SupplierCode', isRequired: true },
    { DisplayLabel: 'Invoice No', value: 'InvoiceNo', key: 'InvoiceNo', isRequired: true },
    { DisplayLabel: 'Invoice Date', value: 'InvoiceDate', key: 'InvoiceDate', isRequired: true },
    { DisplayLabel: 'LotNo', value: 'LotNo', key: 'LotNo', isRequired: true },
    { DisplayLabel: 'Type', value: 'Type', key: 'Type', isRequired: true },
    {
      DisplayLabel: 'Bag Description',
      value: 'BagDescription',
      key: 'BagDescription',
      isRequired: true,
    },
    {
      DisplayLabel: 'Internal Code',
      value: 'InternalCode',
      key: 'InternalCode',
      isRequired: false,
    },
    { DisplayLabel: 'Description', value: 'Description', key: 'Description', isRequired: false },
    { DisplayLabel: 'Carat', value: 'Cts', key: 'Cts', isRequired: true },
    { DisplayLabel: 'Pcs', value: 'Pcs', key: 'Pcs', isRequired: true },
    { DisplayLabel: 'Color', value: 'Color', key: 'Color', isRequired: false },
    { DisplayLabel: 'Shape', value: 'Shape', key: 'Shape', isRequired: false },
    { DisplayLabel: 'Size', value: 'Size', key: 'Size', isRequired: false },
    { DisplayLabel: 'Clarity', value: 'Clarity', key: 'Clarity', isRequired: false },
    {
      DisplayLabel: 'Ref Supplier Code',
      value: 'RefSupplierCode',
      key: 'RefSupplierCode',
      isRequired: false,
    },
    {
      DisplayLabel: 'Mining Companies',
      value: 'MiningCompanies',
      key: 'MiningCompanies',
      isRequired: true,
    },
    {
      DisplayLabel: 'Country Of Origin',
      value: 'CountryOfOrigin',
      key: 'CountryOfOrigin',
      isRequired: true,
    },
    {
      DisplayLabel: 'Synthetic Diamond Per',
      value: 'SyntheticDiamondPer',
      key: 'SyntheticDiamondPer',
      isRequired: false,
    },
    { DisplayLabel: 'Sub Types', value: 'SubTypes', key: 'SubTypes', isRequired: false },
    { DisplayLabel: 'Sub Category', value: 'SubCategory', key: 'SubCategory', isRequired: false },
    { DisplayLabel: 'KT', value: 'KT', key: 'KT', isRequired: false },
    { DisplayLabel: 'Notes', value: 'Notes', key: 'Notes', isRequired: false },
    { DisplayLabel: 'CertReportNo', value: 'CertReportNo', key: 'CertReportNo', isRequired: true },
    { DisplayLabel: 'CertLab', value: 'CertLab', key: 'CertLab', isRequired: true },
    { DisplayLabel: 'Rough Carat', value: 'RoughCarat', key: 'RoughCarat', isRequired: false },
    {
      DisplayLabel: 'Rough Vid Path',
      value: 'RoughVidPath',
      key: 'RoughVidPath',
      isRequired: false,
    },
    { DisplayLabel: 'KPUrl', value: 'KPUrl', key: 'KPUrl', isRequired: false },
    { DisplayLabel: 'Plan Vid Path', value: 'PlanVidPath', key: 'PlanVidPath', isRequired: false },
    { DisplayLabel: 'Cut', value: 'Cut', key: 'Cut', isRequired: false },
    { DisplayLabel: 'Polish', value: 'Polish', key: 'Polish', isRequired: false },
    { DisplayLabel: 'Symn', value: 'Symn', key: 'Symn', isRequired: false },
    { DisplayLabel: 'FL', value: 'FL', key: 'FL', isRequired: false },
    { DisplayLabel: 'Mes1', value: 'Mes1', key: 'Mes1', isRequired: false },
    { DisplayLabel: 'Mes2', value: 'Mes2', key: 'Mes2', isRequired: false },
    { DisplayLabel: 'Mes3', value: 'Mes3', key: 'Mes3', isRequired: false },
    { DisplayLabel: 'DepthPer', value: 'DepthPer', key: 'DepthPer', isRequired: false },
    { DisplayLabel: 'Table Width', value: 'TableWidth', key: 'TableWidth', isRequired: false },
    { DisplayLabel: 'Ratio', value: 'Ratio', key: 'Ratio', isRequired: false },
    { DisplayLabel: 'Girdle', value: 'Girdle', key: 'Girdle', isRequired: false },
    { DisplayLabel: 'Crown height', value: 'Crownheight', key: 'Crownheight', isRequired: false },
    { DisplayLabel: 'Crown Angle', value: 'CrownAngle', key: 'CrownAngle', isRequired: false },
    {
      DisplayLabel: 'Pavilion Depth',
      value: 'PavilionDepth',
      key: 'PavilionDepth',
      isRequired: false,
    },
    {
      DisplayLabel: 'Pavilion Angel',
      value: 'PavilionAngel',
      key: 'PavilionAngel',
      isRequired: false,
    },
    { DisplayLabel: 'H_and_A', value: 'H_and_A', key: 'H_and_A', isRequired: false },
    { DisplayLabel: 'Inscription', value: 'Inscription', key: 'Inscription', isRequired: false },
    { DisplayLabel: 'Comments', value: 'Comments', key: 'Comments', isRequired: false },
    { DisplayLabel: 'Cert URL', value: 'CertURL', key: 'CertURL', isRequired: false },
    { DisplayLabel: 'Vid Path', value: 'VidPath', key: 'VidPath', isRequired: false },
    {
      DisplayLabel: 'Is Call Supplier API',
      value: 'IsCallSupplierAPI',
      key: 'IsCallSupplierAPI',
      isRequired: true,
    },
  ],
  RMCodeMappingField: [
    { DisplayLabel: 'RM Code', value: 'RMCode', key: 'RMCode', isRequired: true },
    { DisplayLabel: 'Material Type', value: 'MaterialType', key: 'MaterialType', isRequired: true },
    { DisplayLabel: 'SubCategory', value: 'SubCategory', key: 'SubCategory', isRequired: false },
    { DisplayLabel: 'Description', value: 'Description', key: 'Description', isRequired: false },
    { DisplayLabel: 'KT', value: 'KT', key: 'KT', isRequired: false },
    { DisplayLabel: 'Shape', value: 'Shape', key: 'Shape', isRequired: false },
    { DisplayLabel: 'Color', value: 'Color', key: 'Color', isRequired: false },
    { DisplayLabel: 'Clarity', value: 'Clarity', key: 'Clarity', isRequired: false },
    { DisplayLabel: 'From Size', value: 'FromSize', key: 'FromSize', isRequired: false },
    { DisplayLabel: 'To Size', value: 'ToSize', key: 'ToSize', isRequired: false },
    { DisplayLabel: 'Seive1', value: 'Seive1', key: 'Seive1', isRequired: false },
    { DisplayLabel: 'Seive2', value: 'Seive2', key: 'Seive2', isRequired: false },
    { DisplayLabel: 'Avg Wt', value: 'AvgWt', key: 'AvgWt', isRequired: false },
    { DisplayLabel: 'Cts1', value: 'Cts1', key: 'Cts1', isRequired: false },
    { DisplayLabel: 'Cts2', value: 'Cts2', key: 'Cts2', isRequired: false },
  ],
  BulkUploadQueryStringTypesArray: ['jewellery-article', 'inward'],
  BulkUploadQueryStringTypesObject: {
    JeweleryArticle: 'jewellery-article',
    Inward: 'inward',
  },
  BulkUploadValidExtensions: ['.zip'],
  LayoutType: [
    {
      label: 'Full Width',
      value: 'Full Width',
    },
    {
      label: 'Half Width',
      value: 'Half Width',
    },
  ],
  LayoutTypeObject: {
    FullWidth: 'Full Width',
    HalfWidth: 'Half Width',
  },
  PersonalizeImageSize: {
    FullWidth: '935 * 420',
    HalfWidth: '460 * 360',
  },
  PersonalizeImageResolution: {
    FullWidth: 935,
    FullHeight: 420,

    HalfWidth: 460,
    HalfHeight: 360,
  },
  ConsumerSoldStatus: {
    Active: 'Active',
    Publish: 'Publish',
    Uploaded: 'Uploaded',
    Deleted: 'Deleted',
    InActive: 'InActive',
  },
  MediaType: {
    Image: 'Image',
    Video: 'Video',
  },
  SoldArticleConsumerList: [
    { label: 'Active ', value: 'Active', id: 1 },
    { label: 'Publish', value: 'Publish', id: 2 },
    // { label: 'Uploaded', value: 'Uploaded', id: 3 },
    // { label: 'Deleted', value: 'Deleted', id: 4 },
    // { label: 'InActive', value: 'InActive', id: 5 }
  ],
  PersonalizeMomentStatus: [
    { label: 'Active ', value: 'Active', id: 1 },
    { label: 'InActive', value: 'InActive', id: 2 },
    { label: 'Deleted', value: 'Deleted', id: 3 },
  ],
  EntityType: {
    Factory: 'Factory',
    Wholesaler: 'Wholesaler',
  },
  DataEntryModes: {
    Manual: 'Manual',
    CSVImport: 'CSVImport',
  },
  TransferToList: [
    { label: 'Factory', value: 'Factory' },
    { label: 'Wholesaler', value: 'Wholesaler' },
    { label: 'Client', value: 'Client' },
  ],
  AckStatus: [
    { label: 'Pending', value: 'Pending' },
    { label: 'Accepted', value: 'Accepted' },
    { label: 'Rejected', value: 'Rejected' },
  ],
  AcknowledgementStatus: {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
  },
  QRCodeStatus: {
    Mapped: 'Mapped',
    UnMapped: 'UnMapped',
  },
  CertifiedStoneStatusFilterList: [
    { label: 'Available', value: 'Available' },
    { label: 'Sold', value: 'Sold' },
    { label: 'Received Pending', value: 'Received Pending' },
  ],
  AuditStatus: [
    { label: 'Audited', value: true },
    { label: 'UnAudited', value: false },
  ],
  CertifiedStoneStatusObj: {
    Available: 'Available',
    Sold: 'Sold',
    ReceivedPending: 'Received Pending',
  },
  CertifiedStoneStatusList: [
    { label: 'Available', value: 'Available' },
    { label: 'Sold', value: 'Sold' },
  ],
  QRCodetype: [
    { label: 'Certified Stone', value: 'Certified Stone' },
    { label: 'Jewellery Article', value: 'Jewellery Article' },
  ],
  QRCodeTypeObj: {
    CertifiedStone: 'Certified Stone',
    JewelleryArticle: 'Jewellery Article',
  },
  Exports: 'Exports',
  Purchase: 'Purchase',
  PolishDiamonds: 'Polish Diamonds(Loose)',
  IsCallSupplierApiList: [
    { label: 'No', value: 'No' },
    { label: 'Yes', value: 'Yes' },
  ],
  Menu: {
    Wholesalers: 'Wholesalers',
    Factory: 'Factory',
    Key: 'FactoryList',
    URL: '/Factory',
  },
  DocumentReferenceType: [
    { value: 'Inward', label: 'Inward' },
    { value: 'Jewellery Article', label: 'Jewellery Article' },
    { value: 'Supplier', label: 'Supplier' },
    { value: 'Client', label: 'Client' },
    { value: 'General', label: 'General' },
    { value: 'Transfer Document', label: 'Transfer Document' },
    { value: 'Certified Stone Transfer Document', label: 'Certified Stone Transfer Document' },
    { value: 'Certified Stone', label: 'Certified Stone' },
  ],
  originTypeOptions: [
    { label: 'Diamond', value: 'Diamond' },
    { label: 'Gold', value: 'Gold' },
  ],
  TenantLogoSize: 2097152,
  TenantLogoSizeBytes: '2 MB',
  TenantLogoResolutionMinHeight: 80,
  TenantLogoResolutionMaxHeight: 100,
  TenantLogoResolutionMinWidth: 80,
  TenantLogoResolutionMaxWidth: 100,
  TenantSupportedFileTypes: ['image/jpeg', 'image/png', 'image/jpg'],
  TenantSupportedFileTypesMessage: '.jpeg , .jpg, .png, ',
  ClientType: [
    { id: 1, value: 'Client', label: 'Client' },
    { id: 1, value: 'Retailer', label: 'Retailer' },
  ],
  BrandLogoSize: 2097152,
  BrandLogoSizeBytes: '2 MB',
  // Brand logo resolution 225 * 85
  BrandLogoResolutionHeight: 85,
  BrandLogoResolutionWidth: 225,
  BrandSupportedFileTypes: ['image/jpeg', 'image/png', 'image/jpg'],
  BrandSupportedFileTypesMessage: '.jpeg , .jpg, .png, ',
  DigitalPassName: 'TOUS_',
  tracemarkDigitalPassName: 'TRACEMARK_',
  ChangePassword: 'Change Password',
  PasswordRegexp: '((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%_!&()]).{6,20})',
  CustomSpinner: {
    Setloader: 'customSpinner/setloader',
    RemoveLoader: 'customSpinner/removeLoader',
  },
  YouTubeURLRegexp: /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/,
  OTPRegexp: '^[0-9]+$',
  AvgwtCtsRegexp: '^[0-9]+(\\.[0-9]{1,4})?$',

  tousLangueges: [
    // {id:1,value:'en-US',label:'English'},
    { id: 2, value: 'es-ES', label: 'Spanish' },
    { id: 3, value: 'ca-ES', label: 'Catalan' },
    { id: 4, value: 'ru-RU', label: 'Russian' },
    { id: 5, value: 'pt-PT', label: 'Portuguese' },
    // {id:6, value:'es-MX',label:'Mexican'}
  ],

  tousV2Langueges: [
    { id: 1, value: 'en-US', label: 'English' },
    { id: 2, value: 'es-ES', label: 'Spanish' },
    { id: 3, value: 'ca-ES', label: 'Catalan' },
    // { id: 4, value: 'ru-RU', label: 'Russian' },
    { id: 5, value: 'pt-PT', label: 'Portuguese' },
    // {id:6, value:'es-MX',label:'Mexican'}
  ],

  tousHavLanguages: [
    { id: 1, value: 'en-US', label: 'English' },
    { id: 2, value: 'es-ES', label: 'Spanish' },
    // { id: 3, value: 'ca-ES', label: 'Catalan' },
    // { id: 4, value: 'ru-RU', label: 'Russian' },
    { id: 5, value: 'pt-PT', label: 'Portuguese' },
    // {id:6, value:'es-MX',label:'Mexican'}
  ],

  // tousJAInfoLangueges: [
  //   { id: 1, value: 'en-US', label: 'English' },
  //   { id: 2, value: 'es-ES', label: 'Spanish' },
  //   { id: 3, value: 'ca-ES', label: 'Catalan' },
  //   { id: 4, value: 'ru-RU', label: 'Russian' },
  //   { id: 5, value: 'pt-PT', label: 'Portuguese' },
  //   { id: 6, value: 'es-MX', label: 'Mexican' }
  // ],

  tracemarkLangueges: [
    { id: 1, value: 'en-US', label: 'English' },
    { id: 2, value: 'es-ES', label: 'Spanish' },
  ],

  tousLanguegesArray: ['es-ES', 'ca-ES', 'pt-PT'],
  tracemarkLanguegesArray: ['en-US', 'es-ES'],

  LanguagesArray: ['en-US', 'pt-PT', 'ru-RU'],

  spanishLanguages: ['es-ES'],

  ConsumerPanels: {
    tousPanel: 'Tous Panel',
    tousPanelV2: 'Tous Panel V2',
    tracemarkPanel: 'Tracemark Panel',
    tousHavConsumerPage: 'Tous HAV Panel',
    tousHavPanelV2: 'Tous HAV Panel V2',
    tousPlatinumPanelV2: 'Tous Platinum Panel V2',
    tousHavPlatinumPanelV2: 'Tous HAV Platinum Panel V2',
    tousGoldAndLabgrownPanel: 'Tous Gold and Labgrown Panel',
  },

  // Langueges: [
  //   // {id:1,value:'en-US',label:'English'},
  //   { id: 2, value: 'es-ES', label: 'Spanish' },
  //   { id: 3, value: 'ca-ES', label: 'Catalan' },
  //   { id: 4, value: 'ru-RU', label: 'Russian' },
  //   { id: 5, value: 'pt-PT', label: 'Portuguese' },
  //   { id: 6, value: 'es-MX', label: 'Mexican' }
  // ],

  // JewellerArtiCleInfoLangueges: [
  //   { id: 1, value: 'en-US', label: 'English' },
  //   { id: 2, value: 'es-ES', label: 'Spanish' },
  //   { id: 3, value: 'ca-ES', label: 'Catalan' },
  //   { id: 4, value: 'ru-RU', label: 'Russian' },
  //   { id: 5, value: 'pt-PT', label: 'Portuguese' },
  //   { id: 6, value: 'es-MX', label: 'Mexican' }
  // ],

  ComponentElement: {
    ImageWithText: 'ImageWithText',
    ImageWithTwoTextHorizontal: 'ImageWithTwoTextHorizontal',
    ImageWithTwoTextVertical: 'ImageWithTwoTextVertical',
    ThreeImage: 'ThreeImage',
    SixImage: 'SixImage',
    HeaderWithBackground: 'HeaderWithBackground',
    HeaderWithLogo: 'HeaderWithLogo',
    TracemarkID: 'TracemarkID',
    TextOnly: 'TextOnly',
    StaticFooter: 'StaticFooter',
    DynamicFooter: 'DynamicFooter',
    ClientLogoWithFullWidth: 'ClientLogoWithFullWidth',
    ClientLogoWithFullWidthAndBackgroundImage: 'ClientLogoWithFullWidthAndBackgroundImage',
    ClientLogoWithTracemarkLogo: 'ClientLogoWithTracemarkLogo',
    LogoWithText: 'LogoWithText',
    Divider: 'Divider',
    TracemarkIDBatch: 'TracemarkIDBatch',
    DynamicFooterBatch: 'DynamicFooterBatch',
    DynamicthreeCertificate: 'DynamicThreeCertificate',
    SingleCertificate: 'SingleCertificate',
  },

  fontList: [
    { id: 1, value: 'Times New Roman', label: 'Times New Roman' },
    { id: 2, value: 'Helvetica', label: 'Helvetica' },
    { id: 3, value: 'Californian FB', label: 'Californian FB' },
    { id: 4, value: 'Bambino', label: 'Bambino' },
    { id: 5, value: 'Didot', label: 'Didot' },
    { id: 6, value: 'Levenim MT', label: 'Levenim MT' },
    { id: 7, value: 'Posterama', label: 'Posterama' },
    { id: 8, value: 'Arial Black', label: 'Arial Black' },
  ],

  items: [
    {
      key: 'HeaderWithLogo',
      name: 'Header with Brand Logo',
      static: true,
      src: 'resources/images/TLS/NoImage.png',
      popoverImage: 'resources/images/PopoverImage/HeaderWithLogo.png',
      fullWidthContent: false,
    },
    {
      key: 'TextOnly',
      name: 'Custom Title',
      static: true,
      content: 'Placeholder Text...',
      fullWidthContent: false,
      popoverImage: 'resources/images/PopoverImage/TextOnly.png',
    },
    {
      key: 'LogoWithText',
      name: 'Icon with text',
      label: '',
      field_name: 'imagetext_',
      src: 'resources/images/TLS/NoImage.png',
      content: 'Placeholder Text...',
      popoverImage: 'resources/images/PopoverImage/LogoWithText.png',
      fullWidthContent: false,
    },
    {
      key: 'ImageWithText',
      name: 'Image with text (2 columns)',
      label: '',
      field_name: 'imagetext_',
      src: 'resources/images/TLS/NoImage.png',
      image_360_view: '',
      image_radioButton_value: 'normalImage',
      content: 'Placeholder Text...',
      swipe: false,
      popoverImage: 'resources/images/PopoverImage/ImageWithText.png',
      fullWidthContent: false,
    },
    {
      key: 'TracemarkID',
      name: 'Tracemark ID (individual)',
      static: true,
      content: 'Placeholder Text...',
      src: 'resources/images/TLS/NoImage.png',
      popoverImage: 'resources/images/PopoverImage/TracemarkID.png',
      fullWidthContent: false,
    },
    {
      key: 'TracemarkIDBatch',
      name: 'Tracemark ID (batch)',
      static: true,
      content: 'Placeholder Text...',
      src: 'resources/images/TLS/NoImage.png',
      popoverImage: 'resources/images/PopoverImage/TracemarkID.png',
      fullWidthContent: false,
    },
    {
      key: 'HeaderWithBackground',
      name: 'Custom Header',
      static: true,
      content: 'Placeholder Text...',
      popoverImage: 'resources/images/PopoverImage/HeaderWithBackground2.png',
      fullWidthContent: false,
    },
    {
      key: 'ImageWithTwoTextVertical',
      name: 'Title, Caption, Picture (3 rows)',
      static: true,
      content: 'Placeholder Text1...',
      content1: 'Placeholder Text2...',
      src: 'resources/images/TLS/NoImage.png',
      fullWidthContent: false,
      popoverImage: 'resources/images/PopoverImage/ImageWithTwoTextVertical.png',
      image_360_view: '',
      image_radioButton_value: 'normalImage',
    },
    {
      key: 'DynamicFooter',
      name: 'Dynamic Certificate (individual)',
      label: '',
      field_name: 'dynamicFooter_individual',
      // image1: 'resources/images/TLS/NoImage.png',
      btnLink2: '',
      image2: 'resources/images/TLS/NoImage.png',
      content: 'Placeholder Text...',
      popoverImage: 'resources/images/PopoverImage/Footer.png',
      fullWidthContent: false,
    },
    // {
    //   key: 'DynamicFooterBatch',
    //   name: 'Dynamic Certificate (batch)',
    //   label: '',
    //   field_name: 'dynamicFooter_batch',
    //   // image1: 'resources/images/TLS/NoImage.png',
    //   btnLink2: '',
    //   image2: 'resources/images/TLS/NoImage.png',
    //   content: 'Placeholder Text...',
    //   popoverImage: 'resources/images/PopoverImage/Footer.png',
    //   fullWidthContent: false,
    // },
    {
      key: 'DynamicThreeCertificate',
      name: 'Dynamic 3 Certificate',
      label: '',
      field_name: 'DynamicThreeCertificate',
      // image1: 'resources/images/TLS/NoImage.png',
      btnLink2: '',
      image2: 'resources/images/TLS/NoImage.png',
      btnLink3: '',
      image3: 'resources/images/TLS/NoImage.png',
      content: 'Placeholder Text...',
      popoverImage: 'resources/images/PopoverImage/Footer.png',
      fullWidthContent: false,
    },
    {
      key: 'StaticFooter',
      name: 'Static Certificate',
      label: '',
      field_name: 'staticFooter_',
      image1: 'resources/images/TLS/NoImage.png',
      image2: 'resources/images/TLS/NoImage.png',
      content: 'Placeholder Text...',
      popoverImage: 'resources/images/PopoverImage/Footer.png',
      fullWidthContent: false,
    },
    {
      key: 'ClientLogoWithFullWidth',
      name: 'Brand Logo in Center above Tracemark',
      static: true,
      src: 'resources/images/TLS/NoImage.png',
      popoverImage: 'resources/images/PopoverImage/ClientLogoWithFullWidth2.png',
      content: 'Tracemark Traceability Panel',
      isBambinoFont: false,
      fullWidthContent: false,
    },
    {
      key: 'ClientLogoWithFullWidthAndBackgroundImage',
      name: 'Brand Logo in Center above Tracemark with background image',
      static: true,
      src: 'resources/images/TLS/NoImage.png',
      image1: '',
      popoverImage: 'resources/images/PopoverImage/ClientLogoWithFullWidth2.png',
      content: 'Tracemark Traceability Panel',
      isBambinoFont: false,
      fullWidthContent: false,
    },
    {
      key: 'ClientLogoWithTracemarkLogo',
      name: 'Brand Logo with Tracemark',
      static: true,
      src: 'resources/images/TLS/NoImage.png',
      popoverImage: 'resources/images/PopoverImage/ClientLogoWithTracemarkLogo.png',
      swipe: false,
      fullWidthContent: false,
    },
    {
      key: 'ImageWithTwoTextHorizontal',
      name: 'Image with text (3 columns)',
      static: true,
      content: 'Placeholder Text1...',
      content1: 'Placeholder Text2...',
      src: 'resources/images/TLS/NoImage.png',
      popoverImage: 'resources/images/PopoverImage/ImageWithTwoTextHorizontal.png',
      fullWidthContent: false,
      image_360_view: '',
      image_radioButton_value: 'normalImage',
    },
    {
      key: 'ThreeImage',
      name: 'Image Gallery (Three)',
      label: '',
      field_name: 'threeImage_',
      image1: 'resources/images/TLS/NoImage.png',
      image2: 'resources/images/TLS/NoImage.png',
      image3: 'resources/images/TLS/NoImage.png',
      image1_360_view: '',
      image1_radioButton_value: 'normalImage',
      image2_360_view: '',
      image2_radioButton_value: 'normalImage',
      image3_360_view: '',
      image3_radioButton_value: 'normalImage',
      popoverImage: 'resources/images/PopoverImage/ThreeImages.png',
      fullWidthContent: false,
    },
    {
      key: 'SixImage',
      name: 'Image Gallery (Six)',
      label: '',
      field_name: 'sixImage_',
      image1: 'resources/images/TLS/NoImage.png',
      image2: 'resources/images/TLS/NoImage.png',
      image3: 'resources/images/TLS/NoImage.png',
      image4: 'resources/images/TLS/NoImage.png',
      image5: 'resources/images/TLS/NoImage.png',
      image6: 'resources/images/TLS/NoImage.png',
      image1_360_view: '',
      image1_radioButton_value: 'normalImage',
      image2_360_view: '',
      image2_radioButton_value: 'normalImage',
      image3_360_view: '',
      image3_radioButton_value: 'normalImage',
      image4_360_view: '',
      image4_radioButton_value: 'normalImage',
      image5_360_view: '',
      image5_radioButton_value: 'normalImage',
      image6_360_view: '',
      image6_radioButton_value: 'normalImage',
      popoverImage: 'resources/images/PopoverImage/SixImages.png',
      fullWidthContent: false,
    },
    {
      key: 'Divider',
      name: 'Divider',
      label: '',
      field_name: 'divider_',
      fullWidthContent: false,
      popoverImage: 'resources/images/PopoverImage/Divider.png',
    },
    {
      key: 'SingleCertificate',
      name: 'Single Certificate',
      label: '',
      field_name: 'SingleCertificate',
      btnLink1: '',
      image1: facetTracemark,
      content: 'Placeholder Text...',
      popoverImage: 'resources/images/PopoverImage/SingleCertificate.png',
      fullWidthContent: false,
    },
  ],

  borderStyleList: [
    { id: 1, value: 'solid', label: 'solid' },
    { id: 2, value: 'dashed', label: 'dashed' },
    { id: 3, value: 'dotted', label: 'dotted' },
    { id: 4, value: 'double', label: 'double' },
  ],

  borderSizeList: [
    { id: 1, value: '1px', label: '1px' },
    { id: 2, value: '2px', label: '2px' },
    { id: 3, value: '3px', label: '3px' },
    { id: 4, value: '4px', label: '4px' },
    { id: 5, value: '5px', label: '5px' },
  ],
  dynamicPanelLogoMinHeight: 180,
  dynamicPanelLogoMaxHeight: 190,
  dynamicPanelLogoMinWidth: 180,
  dynamicPanelLogoMaxWidth: 190,
  clientLogoSize: 21076377.6,
  panelImagesize: 101000,

  Locales: ['en-US', 'es-ES', 'ca-ES', 'ru-RU', 'pt-PT', 'es-MX', 'fr-FR', 'de-DE'],

  dynamicPanelFlags: {
    miningCompany: '/%#Diamond Mining Company#%/g',
    countryofOrigin: '%#Country of Diamond Origin#%',
    productName: '%#ProductName#%',
    productDescription: '%#ProductDescription#%',
    articleName: '%#ArticleName#%',
    referenceNo: '%#ReferenceNo#%',
    nonTraceableMaterial: '%#NonTraceableMaterial#%',
    finalProduct: '%#Final Product#%',
    finalProductComposition: '%#Final Product Composition#%',
    casting: '%#Casting#%',
    polishing: '%#Polishing#%',
    filling: '%#Filling#%',
    CADDesign: '%#CAD Design#%',
    manufacturing: '%#Manufacturing#%',
    Setting: '%#Setting#%',
    sketch: '%#Sketch#%',
    carat: '%#KT#%',
  },

  imageFlagArray: [
    '%#Final Product#%',
    '%#Final Product Composition#%',
    '%#Casting#%',
    '%#Polishing#%',
    '%#Filling#%',
    '%#CAD Design#%',
    '%#Manufacturing#%',
    '%#Setting#%',
    '%#Sketch#%',
  ],

  flagStaticData: {
    miningCompany: 'Alrosa',
    countryofOrigin: 'Russia',
    articleName: 'Diamond Ring',
    productName: 'Queen of Diamonds Solitaire Ring',
    productDescription:
      'The most stunning solitaire design that will make your special occasions even more memorable, we promise.',
    referenceNo: '087564',
    nonTraceableMaterial: 'Fairmined Gold',
    carat: '18KT',
  },

  threeImageUpload: [
    { image: 'image1', upload: 'img1FileInput' },
    { image: 'image2', upload: 'img2FileInput' },
    { image: 'image3', upload: 'img3FileInput' },
  ],
  sixImageUpload: [
    { image: 'image1', upload: 'img61FileInput', textboxvalue: 'image61' },
    { image: 'image2', upload: 'img62FileInput', textboxvalue: 'image62' },
    { image: 'image3', upload: 'img63FileInput', textboxvalue: 'image63' },
    { image: 'image4', upload: 'img64FileInput', textboxvalue: 'image64' },
    { image: 'image5', upload: 'img65FileInput', textboxvalue: 'image65' },
    { image: 'image6', upload: 'img66FileInput', textboxvalue: 'image66' },
  ],
  staticFooterImageUpload: [
    { image: 'image1', upload: 'imgs1FileInput', textboxvalue: 'images1' },
    { image: 'image2', upload: 'imgs2FileInput', textboxvalue: 'images2' },
  ],

  imageDefaultURL: 'resources/images/TLS/NoImage.png',
  image360DefaultURL: 'resources/images/TLS/360-view.png',
  previewDefaultURL: 'resources/images/TLS/sample_image.png',
  componentType: {
    digitalID: 'Digital ID (Batch)',
    dynamicCertificate: 'Dynamic Certificate (Batch)',
  },
  imageType: {
    normalImage: 'normalImage',
    image360View: '360ViewImage',
  },
}
export default dataConstant
